<div class="modal-header">
  <h4 class="modal-title">{{ 'workflow_data_store.state.title' | translate }}</h4>
  <button type="button" class="btn-close" (click)="hide()" aria-label="Close"></button>
</div>

<div class="modal-body">
  <div class="row g-3 align-items-end mb-3">
    <div class="col-lg-6">
      <label class="form-label">{{ 'workflow_data_store.state.prefix' | translate }}</label>
      <input
        class="form-control"
        [ngModel]="prefix"
        (ngModelChange)="onPrefixChange($event)"
        [placeholder]="'workflow_data_store.state.prefix-placeholder' | translate"
      >
    </div>

    <div class="col-lg-3">
      <label for="workflow-data-store-status" class="form-label">{{ 'workflow_data_store.state.status' | translate }}</label>
      <p-select
        inputId="workflow-data-store-status"
        [ngModel]="status"
        (ngModelChange)="onStatusChange($event)"
        [options]="statusOptions"
        [placeholder]="'workflow_data_store.state.all-statuses' | translate"
        [showClear]="true"
        [fluid]="true"
      >
        <ng-template let-statusOption pTemplate="selectedItem">
          {{ statusOption | translate }}
        </ng-template>
        <ng-template let-statusOption pTemplate="item">
          {{ statusOption | translate }}
        </ng-template>
      </p-select>
    </div>

    <div class="col-lg-3 d-flex justify-content-lg-end gap-2">
      @if (canEdit) {
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="startAddRow()"
        >
          {{ 'workflow_data_store.state.add-record' | translate }}
        </button>
      }
    </div>
  </div>

  <app-error [error]="recordsError"></app-error>

  <div class="table-responsive workflow-data-store-table">
    <table class="table table-striped table-bordered align-middle mb-0">
      <thead>
        <tr>
          <th>{{ 'workflow_data_store.state.key' | translate }}</th>
          <th>{{ 'workflow_data_store.state.value' | translate }}</th>
          <th>{{ 'workflow_data_store.state.status' | translate }}</th>
          <th>{{ 'workflow_data_store.state.owner-worker' | translate }}</th>
          <th>{{ 'workflow_data_store.state.owner-handheld' | translate }}</th>
          <th>{{ 'workflow_data_store.state.lease-until' | translate }}</th>
          <th>{{ 'workflow_data_store.state.updated-at' | translate }}</th>
          @if (canEdit) {
            <th class="text-end"></th>
          }
        </tr>
      </thead>
      <tbody>
        @if (newRow) {
          <tr>
            <td>
              <input class="form-control form-control-sm" [(ngModel)]="newRow.key">
            </td>
            <td>
              <textarea class="form-control form-control-sm font-monospace" rows="6" [(ngModel)]="newRow.valueText"></textarea>
              @if (newRow.errorKey) {
                <div class="text-danger small mt-1">{{ newRow.errorKey | translate }}</div>
              }
            </td>
            <td colspan="5"></td>
            <td class="text-end">
              <div class="d-flex flex-column gap-1">
                <button type="button" class="btn btn-success btn-sm" (click)="saveNewRow()" [disabled]="newRow.saving" data-bs-toggle="tooltip" data-bs-placement="top" [title]="'save' | translate">
                  <span class="material-symbols-outlined">check</span>
                </button>
                <button type="button" class="btn btn-danger btn-sm" (click)="cancelAddRow()" [disabled]="newRow.saving" data-bs-toggle="tooltip" data-bs-placement="top" [title]="'cancel' | translate">
                  <span class="material-symbols-outlined">close</span>
                </button>
              </div>
            </td>
          </tr>
        }

        @for (row of rows; track row.key) {
          <tr>
            <td>{{ row.key }}</td>
            <td>
              @if (row.editing) {
                <textarea class="form-control form-control-sm font-monospace" rows="6" [(ngModel)]="row.valueText"></textarea>
                @if (row.errorKey) {
                  <div class="text-danger small mt-1">{{ row.errorKey | translate }}</div>
                }
              } @else {
                <pre class="mb-0 small font-monospace">{{ row.valueText }}</pre>
              }
            </td>
            <td>{{ row.status | translate }}</td>
            <td>{{ row.ownerWorkerId }}</td>
            <td>{{ row.ownerHandheldId }}</td>
            <td>{{ row.leaseUntil ? (row.leaseUntil | date:'short') : ''}}</td>
            <td>{{ row.updatedAt ? (row.updatedAt | date:'short') : '' }}</td>
            @if (canEdit) {
              <td class="text-end">
                @if (row.editing) {
                  <div class="d-flex flex-column gap-1">
                    <button type="button" class="btn btn-success btn-sm" (click)="saveRow(row)" [disabled]="row.saving" data-bs-toggle="tooltip" data-bs-placement="top" [title]="'save' | translate">
                      <span class="material-symbols-outlined">check</span>
                    </button>
                    <button type="button" class="btn btn-danger btn-sm" (click)="cancelEdit(row)" [disabled]="row.saving" data-bs-toggle="tooltip" data-bs-placement="top" [title]="'cancel' | translate">
                      <span class="material-symbols-outlined">close</span>
                    </button>
                  </div>
                } @else {
                  <div class="d-flex flex-column gap-1 align-items-end">
                    <button type="button" class="btn btn-warning btn-sm" (click)="startEdit(row)" data-bs-toggle="tooltip" data-bs-placement="top" [title]="'edit' | translate">
                      <span class="material-symbols-outlined">edit</span>
                    </button>
                    <button type="button" class="btn btn-danger btn-sm" (click)="deleteRow(row)" [disabled]="row.deleting" data-bs-toggle="tooltip" data-bs-placement="top" [title]="'delete' | translate">
                      <span class="material-symbols-outlined">delete</span>
                    </button>
                    @if (row.deleteErrorKey) {
                      <div class="text-danger small">{{ row.deleteErrorKey | translate }}</div>
                    }
                  </div>
                }
              </td>
            }
          </tr>
        }

        @if (!loadingRecords && rows.length === 0 && !recordsError) {
          <tr>
            <td [attr.colspan]="canEdit ? 8 : 7" class="text-center text-muted py-4">
              {{ 'workflow_data_store.state.no-records' | translate }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="hide()">{{ 'close' | translate }}</button>
</div>
